export const bcSessionKeys = {
  cookie: {
    key: 'bc-cct'
  },
  storage: {
    key: 'bc-user',
    drafts: 'drafts',
    emailCompose: 'email-compose',
    emailComposeWorkItem: 'email-compose-work-item',
    openWorkItemList: 'open-work-item-list',
    focusedWorkItem: 'focused-work-item',
    expandedMode: 'expanded-mode',
    restApiHost: 'rest-api-host',
    remoteControlRoute: 'remote-control-route-',
    fileUploadHost: 'file-upload-host',
    lensWorkItem: 'lens-work-item',
    services: 'services',
    userPermissions: 'user-permissions',
    accountPermissions: 'account-permissions',
    serviceAccess: 'service-access',
    queueViewColumnSettings: 'qv-tab-settings-',
    queueViewColumnSort: 'qv-column-settings-sort-',
    queueViewSelectedTabId: 'qv-selected-tab',
    queueViewSelectedChannelType: 'qv-selected-channel',
    queueViewSelectedFolderId: 'qv-selected-folder-',
    defaultSwimlanes: 'default-lane',
    chatPostFix: '-chat',
    aiChatPostFix: '-ai-chat',
    textChatPostFix: '-text-chat',
    emailPostFix: '-email',
    queueViewSelectedDate: 'qv-selected-date',
    fontSizePercentage: 'font-size-percentage',
    accessibilitySettings: 'accessibility-settings',
    confirmClosingDisabled: 'confirm-closing-disabled',
    liveWorkloadSelectedTab: 'lw-selected-tab',
    liveWorkloadAgentsColumnSort: 'lw-agents-column-sort-',
    genesysCloudApiConfig: 'genesys-cloud-api-config'
  }
};
